import type { FeatureModule } from '../types';
import optionsTradingFeature from './options-trading';
import unifiedAccountsFeature from './unified-accounts';

export const financeFeatures: FeatureModule[] = [optionsTradingFeature, unifiedAccountsFeature];
